import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sign-up-page-header" }, null, -1)
const _hoisted_2 = { class: "sign-up-page" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sign-up-page-background-noise" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "skyline-logo" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignUpComponent = _resolveComponent("SignUpComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_SignUpComponent, {
        onSignup: _ctx.onSignup,
        error: _ctx.error,
        isLoading: _ctx.isLoading,
        class: "login-component"
      }, null, 8, ["onSignup", "error", "isLoading"])
    ])
  ], 64))
}